import { useTranslate } from "Shared/hooks/translations/useTranslate"
import { add, formatDistance, intervalToDuration } from "date-fns"
import { useEffect, useState } from "react"

type UseSessionTimeTitleProps = {
  startsAt: Date | null
  endsAt?: Date | null
}

export const useSessionTimeTitle = ({
  startsAt,
  endsAt = null,
}: UseSessionTimeTitleProps) => {
  const t = useTranslate()
  const [title, setTitle] = useState(t("interview.join_page.default_title"))

  useEffect(() => {
    let checkTimer: number

    const checkTimes = () => {
      if (!startsAt) return

      const now = new Date(Date.now())
      let timeToNextCheck = Infinity

      if (endsAt && endsAt < now) {
        setTitle(t("interview.join_page.title_ended"))
      } else if (startsAt < now) {
        setTitle(t("interview.join_page.title_started"))
        timeToNextCheck = 1000
      } else {
        const interval = intervalToDuration({ start: now, end: startsAt })

        if (startsAt < add(now, { minutes: 1 })) {
          setTitle(
            t("interview.join_page.title_future", {
              time: interval.seconds?.toString() + " seconds",
            })
          )
          timeToNextCheck = 1000 // 1 second
        } else {
          setTitle(
            t("interview.join_page.title_future", {
              time: formatDistance(startsAt, now),
            })
          )
          if ((interval.days || 0) > 0) {
            timeToNextCheck = 1000 * 60 * 60 // 1 hour
          } else {
            timeToNextCheck = 1000 * 60 // 1 minute
          }
        }
      }

      if (timeToNextCheck < Infinity) {
        checkTimer = window.setTimeout(checkTimes, timeToNextCheck)
      }
    }

    checkTimes()

    return () => clearTimeout(checkTimer)
  }, [startsAt, endsAt])

  return title
}
